import Ammo from 'ammo.js';

// todo: think about it
// eslint-disable-next-line
// @ts-ignore
const load: Promise<void> = Ammo(Ammo);

export { Ammo, load };
